import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantEditEmploymentPage = {
  alert: {
    error: 'coapplicant-edit-employment.alert.error',
  },
  footer: {
    root: 'coapplicant-edit-employment.footer.root',
  },
  form: {
    cancelButton: 'coapplicant-edit-employment.form.cancel-button',
    employerNameInput: 'coapplicant-edit-employment.form.employer-name-input',
    employerNameInputError:
      'coapplicant-edit-employment.form.employer-name-input-error',
    employmentDurationSelect:
      'coapplicant-edit-employment.form.employment-duration-select',
    employmentDurationSelectError:
      'coapplicant-edit-employment.form.employment-duration-select-error',
    employmentStatusSelect:
      'coapplicant-edit-employment.form.employment-status-select',
    employmentStatusSelectError:
      'coapplicant-edit-employment.form.employment-status-select-error',
    employmentTypeSelect:
      'coapplicant-edit-employment.form.employment-type-select',
    employmentTypeSelectError:
      'coapplicant-edit-employment.form.employment-type-select-error',
    grossAnnualIncomeInput:
      'coapplicant-edit-employment.form.gross-annual-income-input',
    grossAnnualIncomeInputError:
      'coapplicant-edit-employment.form.gross-annual-income-input-error',
    h1: 'coapplicant-edit-employment.form.h1',
    h2: 'coapplicant-edit-employment.form.h2',
    jobTitleInput: 'coapplicant-edit-employment.form.job-title-input',
    jobTitleInputError:
      'coapplicant-edit-employment.form.job-title-input-error',
    previousEmployerNameInput:
      'coapplicant-edit-employment.form.previous-employer-name-input',
    previousEmployerNameInputError:
      'coapplicant-edit-employment.form.previous-employer-name-input-error',
    previousEmploymentGrossAnnualIncomeInput:
      'coapplicant-edit-employment.form.previous-employment-gross-annual-income-input',
    previousEmploymentGrossAnnualIncomeInputError:
      'coapplicant-edit-employment.form.previous-employment-gross-annual-income-input-error',
    previousEmploymentH3:
      'coapplicant-edit-employment.form.previous-employment-h3',
    previousEmploymentJobTitleInput:
      'coapplicant-edit-employment.form.previous-employment-job-title-input',
    previousEmploymentJobTitleInputError:
      'coapplicant-edit-employment.form.previous-employment-job-title-input-error',
    previousEmploymentRoot:
      'coapplicant-edit-employment.form.previous-employment-root',
    previousEmploymentTypeSelect:
      'coapplicant-edit-employment.form.previous-employment-type-select',
    previousEmploymentTypeSelectError:
      'coapplicant-edit-employment.form.previous-employment-type-select-error',
    root: 'coapplicant-edit-employment.form.root',
    submitButton: 'coapplicant-edit-employment.form.submit-button',
    unemploymentGrossAnnualIncomeInput:
      'coapplicant-edit-employment.form.unemployment-gross-annual-income-input',
    unemploymentGrossAnnualIncomeInputError:
      'coapplicant-edit-employment.form.unemployment-gross-annual-income-input-error',
    unemploymentTypeSelect:
      'coapplicant-edit-employment.form.unemployment-type-select',
    unemploymentTypeSelectError:
      'coapplicant-edit-employment.form.unemployment-type-select-error',
  },
  header: {
    drawerButton: 'coapplicant-edit-employment.header.drawer-button',
    previousStepButton:
      'coapplicant-edit-employment.header.previous-step-button',
    root: 'coapplicant-edit-employment.header.root',
  },
  progress: {
    root: 'coapplicant-edit-employment.progress.root',
  },
} as const satisfies PageLocatorMap;
